<template>
    <div class="scroll-image-container" ref="imgsccc">
        <div
            class="scroll-image-wrapper"
            :style="{ transform: `translateX(${scrollX}px)` }"
            @touchstart="handleTouchStart"
            @touchmove="handleTouchMove"
            @touchend="handleTouchEnd"
        >
            <div
                v-for="(image, index) in cases"
                :key="index"
                style="margin-right: 20px"
                @load="imageLoaded"
                ref="imgdiv"
            >
                <img :src="image.img" />
                <div class="imgBom">
                    <h2 class="title">{{ image.title }}</h2>
                    <p class="con">{{ image.content }}</p>
                </div>
            </div>
        </div>
        <div class="custom-scrollbar">
            <div
                class="scrollbar-thumb"
                :style="{
                    width: scrollbarWidth + 'px',
                    left: scrollbarLeft + 'px',
                }"
            ></div>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="88%"
            :before-close="handleClose"
        >
            <button class="nav-button prev-button" @click="par()">&lt;</button>
            <button class="nav-button next-button" @click="next()">&gt;</button>
            <div style="height: 50%; width: 95%" class="imgBox">
                <img :src="ImgUrl" alt="" style="height: 100%; width: 100%" />
            </div>
            <div style="height: 50%; width: 95%">
                <h3 style="margin: 0 0 5px 0; text-align: center">案例简介</h3>
                <div v-html="processedString" style="line-height: 1.4"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            images: [
                require("@/assets/tecImg/图片1.png"),
                require("@/assets/tecImg/图片2.png"),
                require("@/assets/tecImg/图片3.png"),
                require("@/assets/tecImg/图片4.png"),
            ],
            cases: [
                {
                    img: require("@/assets/tecImg/图片1.png"),
                    title: "智慧检修仿真系统",
                    content: "客户单位：东方电气集团东方电机有限公司",
                },
                {
                    img: require("@/assets/tecImg/图片2.png"),
                    title: "红外&SAR仿真系统",
                    content: "客户单位：某高校&中航&中物院",
                },
                {
                    img: require("@/assets/tecImg/图片3.png"),
                    title: "综合演练系统",
                    content: "客户单位：某部队",
                },
                {
                    img: require("@/assets/tecImg/图片4.png"),
                    title: "人机工效评估系统",
                    content: "客户单位：商飞北研&中物院&沃飞长空",
                },
            ],
            scrollX: 0,
            touchStartX: 0,
            initialScrollX: 0,
            animationFrameId: null,
            scrollbarWidth: 0,
            scrollbarLeft: 0,
            loadedImagesCount: 0,
            clickThreshold: 10,
            isClick: false,
            dialogVisible: false,
            IndexNum: 0,
            clickNum: 0,
            ImgUrl: require("../assets/y0/图片0.png"),
            tableText: [
                {
                    name: "东方电气集团东方电机有限公司",
                    value: "1、基于真实数据还原水电站场景、发电机、配套设备精确模型。；2、跨平台应用，能够在多个硬件平台上完成虚拟训练操作（PC、VR、PAD和CAVE）。；3、真实安装拆解流程三维还原，数十个课件培训以及考核，数千个可操作步骤。；4、数字孪生应用接口，可接入真实传感器数据。；5、二次开发接口，后续可增加课件以及便捷发布。；6、提供典型案例、运行仿真、状态监测、专家讲解和检修培训模块。；7、支持异地操作使用，按照权限开放相应的内容。",
                },
                {
                    name: "某高校&中航某单位&中物院某所",
                    value: "1、基于普朗克黑体辐射理论计算物体热辐射。；2、基于SAR回波计算和目标RCS数据计算回波数据。；3、解析Modtran数据为红外仿真提供大气路径辐射、透过率、太阳辐射、地球辐射和天空辐射等数据。；4、支持火焰、爆炸、烟雾、扬尘和尾迹等特效仿真。；5、支持外部数据实时驱动和控制。；6、支持仿真图像和视频的保存和录制。",
                },
                {
                    name: "某部队",
                    value: "1、真实大范围地形、卫星影像与地形贴图无缝混合现实。；2、可模拟雨、雪和雾天气效果。；3、可编辑战场单位元素、实时生成战场单位。；4、支持导调指挥操作。；5、支持多设备协同演练。",
                },
                {
                    value: "1、提供RULA和REBA分析模式，实时计算人体姿态并记录舒适度结果，并以三维方式在人体姿态上显示出舒适度结果。；2、支持专业的视野分析模式（Binocular、Ambinocular、Monocular Left、Monocular Right和Stereo），实时计算双眼聚焦点，可输出AOI区域注视时间。；3、支持人体多肢体的包络面检测，提供点、线和面模式分析模式，实时计算可达性结果并三维高亮显示。；4、全身肢体参与碰撞检查，实时记录碰撞的肢体与虚拟设备，可输出行为绩效结果。；5、支持眼动和心率等设备的数据接入。；6、采用多人协同架构，支持全身动捕系统，机组动作互相可见，设备操作实时反馈，分析计算实时记录。；",
                },
            ],
        };
    },
    watch: {
        IndexNum() {
            this.ImgUrl = require(`../assets/y${this.IndexNum}/图片${this.clickNum}.png`);
        },
        clickNum() {},
        dialogVisible() {
            if (!this.dialogVisible) {
                this.clickNum = 0;
                this.IndexNum = 0;
            } else {
                if (this.IndexNum == 0) {
                    this.ImgUrl = require(`../assets/y0/图片0.png`);
                }
            }
        },
    },
    computed: {
        processedString() {
            const items = this.tableText[this.IndexNum].value.split("；");
            // 去除最后一个可能为空的元素
            if (items[items.length - 1] === "") {
                items.pop();
            }
            // 为每个元素添加换行标签
            return items.map((item) => `${item}<br>`).join("");
        },
    },
    methods: {
        par() {
            if (this.clickNum > 0) {
                this.clickNum--;
            }

            this.ImgUrl = require(`../assets/y${this.IndexNum}/图片${this.clickNum}.png`);
        },
        next() {
            switch (this.IndexNum) {
                case 0:
                    if (this.clickNum < 5) {
                        this.clickNum++;
                    }
                    break;
                case 1:
                    if (this.clickNum < 3) {
                        this.clickNum++;
                    }
                    break;
                case 2:
                    if (this.clickNum < 5) {
                        this.clickNum++;
                    }
                    break;
                case 3:
                    if (this.clickNum < 5) {
                        this.clickNum++;
                    }
                    break;

                default:
                    break;
            }

            this.ImgUrl = require(`../assets/y${this.IndexNum}/图片${this.clickNum}.png`);
        },
        handleClose(done) {
            done();
        },
        open(index) {
            if (this.isClick) {
                const clickedImage = this.cases[index];
                this.IndexNum = index;
                this.dialogVisible = true;
            }
        },
        handleTouchStart(event) {
            event.preventDefault();
            event.stopPropagation();
            this.touchStartX = event.touches[0].clientX;
            this.initialScrollX = this.scrollX;
            const wrapper = this.$el.querySelector(".scroll-image-wrapper");
            wrapper.style.willChange = "transform";
            this.isClick = true;
        },
        handleTouchMove(event) {
            event.preventDefault();
            event.stopPropagation();
            const currentX = event.touches[0].clientX;
            const deltaX = Math.abs(currentX - this.touchStartX);
            if (deltaX > this.clickThreshold) {
                this.isClick = false;
            }
            const newScrollX =this.initialScrollX + (currentX - this.touchStartX);

            let b = window.innerWidth * 0.1;
            let a = this.$refs.imgdiv;
            let sum = 0;
            for (let i = 0; i < a.length; i++) {
                sum += a[i].offsetWidth - 60;
            }
            const maxScroll = -(sum - b);
            const finalScrollX = Math.max(Math.min(newScrollX, 0), maxScroll);

            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
            }
            this.animationFrameId = requestAnimationFrame(() => {
                this.scrollX = finalScrollX;
                this.updateScrollbar();
            });
        },
        handleTouchEnd(event) {
            const wrapper = this.$el.querySelector(".scroll-image-wrapper");
            wrapper.style.willChange = "auto";
            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
            }
            this.updateScrollbar();

            if (this.isClick) {
                const target = event.changedTouches[0].target;
                const imageDiv = target.closest(".scroll-image-wrapper > div");
                if (imageDiv) {
                    const index = Array.from(
                        imageDiv.parentNode.children
                    ).indexOf(imageDiv);
                    this.open(index);
                }
            }
            this.isClick = false;
        },
        updateScrollbar() {
            const scrollContainer = this.$refs.imgsccc;
            if (scrollContainer) {
                const trackWidth = scrollContainer.offsetWidth;
                // console.log(this.$refs.imgdiv[0].offsetWidth);
                let b = window.innerWidth * 0.1;
                let a = this.$refs.imgdiv;
                let sum = 0;
                for (let i = 0; i < a.length; i++) {
                    sum += a[i].offsetWidth - 60;
                }

                const imageScrollRange = sum - b;
                const imageScrollPosition = -this.scrollX;

                const { scrollbarWidth, scrollbarPosition } =
                    this.calculateScrollbarPosition(
                        imageScrollPosition,
                        imageScrollRange,
                        trackWidth
                    );

                this.scrollbarWidth = scrollbarWidth;
                this.scrollbarLeft = scrollbarPosition;
            }
        },
        calculateScrollbarPosition(
            imageScrollPosition,
            imageScrollRange,
            trackWidth
        ) {
            const scrollbarWidth = trackWidth / 4;
            const scrollbarMaxMove = trackWidth - scrollbarWidth;
            const scrollbarPosition =
                (imageScrollPosition / imageScrollRange) * scrollbarMaxMove;

            return {
                scrollbarWidth,
                scrollbarPosition,
            };
        },
        imageLoaded() {
            this.loadedImagesCount++;
            if (this.loadedImagesCount === this.images.length) {
                this.$nextTick(() => {
                    this.updateScrollbar();
                });
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.updateScrollbar();
        });
    },
    beforeDestroy() {
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
        }
    },
};
</script>

<style scoped>
.scroll-image-container {
    width: 100%;
    height: 34%;
    overflow: hidden;
    position: relative;
}

.scroll-image-wrapper {
    display: flex;
    transition: transform 0.1s ease-out;
    will-change: transform;
    width: auto;
    height: 90%;
}

.scroll-image-wrapper img {
    min-width: 300px;
    height: 200px;
    /* width: 320px; */
    max-width: 320px;
}

.custom-scrollbar {
    position: relative;
    height: 4px;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 2px;
    /* bottom: 0; */
}

.scrollbar-thumb {
    position: absolute;
    height: 100%;
    background-color: rgba(11, 124, 181);
    border-radius: 2px;
    transition: left 0.1s ease-out;
}
.imgBom {
    height: 35%;
    width: 100%;
    background-color: #fff;
}
.title {
    margin-top: 0;
    font-size: 20px;
}
.con {
    font-size: 18px;
}
::v-deep .el-dialog__body {
    min-height: 60vh;
    /* height: 60vh; */
}
.nav-button {
    position: absolute;
    top: 27%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    height: 40px;
    width: 40px;
    border: none;
    border-radius: 20px;
    font-size: 20px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    transition: opacity 0.3s ease;
    z-index: 10;
}

/* 上一页按钮位置样式 */
.prev-button {
    left: 10px;
}

/* 下一页按钮位置样式 */
.next-button {
    right: 10px;
}
</style>